import * as React from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PageTitle from "../../Shared/Title";
import CandidateInformation from "../../Shared/CandidateInformation/CandidateInformation";
import Collapsible from "react-collapsible";
import SkeletonWidget from "../../Shared/Skeleton";
import { candTriggerName, ErrorComponent } from "../../ReusableComponents";
import TasksComponent from "./Task/TasksComponent";
import {
  GENERATE_PROJECTION_SUCCESS_MSG,
  MAX_FORECASTING_HOURS_MSG,
  NO_DOC_FOR_CREDENTIALING,
  OVERRIDE_EXISTING_PROJECTION_GENERATE_CONFIRMATION_MSG,
  REJECT_CANDIDATE,
  REJECT_CANDIDATE_SUCCESS_MSG,
  SAVE_UNSAVED_INTERVIEW_RESULT,
  SELECT_ATLEAST_ONE_SUBMITTED,
  SELECT_ATLEAST_ONE_TASK,
  SELECT_ONE_TASK_TO_SEND,
  SELECT_ONLY_SUBMITTED_TASK,
  SELECT_SUBMITTED_TASK,
  TASK_WARNING_MSG,
  TEMP_CRED_MSG,
  WITHDRAW_CANDIDATE,
  WITHDRAW_CANDIDATE_SUCCESS_MSG,
} from "../../Shared/AppMessages";
import auth from "../../Auth";
import {
  AuthRoleType,
  CandidateWorkflow,
  CandidateWorkflowActionBtns,
  CandSubmissionSubStatusIds,
  CandSubStatusIds,
  DocStatus,
  DocType,
  EntityType,
  isRoleType,
  SettingCategory,
  SETTINGS
} from "../../Shared/AppConstants";
import { Comment } from "../../Shared/Comment/Comment";
import FormActions from "../../Shared/Workflow/FormActions";
import { CAND_SUB_MANAGE_URL } from "../../Shared/ApiUrls";
import CloseLink from "../../Shared/CloseLink";
import { ConfirmationModal } from "../../Shared/ConfirmationModal";
import {
  SUBMIT_ONBOARD_MSG,
  FULLY_CREDENTIALS_ONBOARD_MSG,
  TEMP_CRED_ONBOARD_SUCCESS_MSG,
  FULLY_CRED_ONBOARD_SUCCESS_MSG,
  SEND_BACK_SUCCESS_MSG,
  SEND_BACK_MSG,
  SUBMIT_ONBOARD_SUCCESS_MSG,
} from "../../Shared/AppMessages";
import {
  NotificationTypeIds,
  CandSubOnBoardTaskStatusIds
} from "../../Shared/AppConstants";
import { Dialog } from "@progress/kendo-react-dialogs";
import SendCredentials from "./SendCredentials/SendCredentials";
import { applySettingFilters, errorToastr, getClientSettingsData, history, localDateTime, successToastr, warningToastr } from "../../../HelperMethods";
import RejectModal from "../../Shared/RejectModal";
import TemporaryModal from "./Task/TemparoryModal";
import CommentHistoryBox from "../../Shared/Comment/CommentHistoryBox";
import BillRateAndExpenses from "../BillRateAndExpenses/BillRateAndExpenses";
import CandSubPresentationInfo from "../../Shared/CandSubPresentationInfo/CandSubPresentationInfo";
import AlertBox from "../../Shared/AlertBox";
import ProjectionTargetDates from "../Projection/ProjectionTargetDates";
import AssignmentProjections from "../Projection/AssignmentProjection/AssignmentProjections";
import { AppPermissions } from "../../Shared/Constants/AppPermissions";
import CommonDataService from "../../Shared/Services/CommonDataService";

export interface ViewOnboardingProps {
  match: any;
}

export interface ViewOnboardingState {
  reqId: string;
  reqNo: string;
  location: string;
  position?: string;
  candidateEmail?: string;
  candidatePhoneNumber?: string;
  candidateMobileNumber?: string;
  candSubDetails: any;
  showLoader?: boolean;
  openCommentBox?: boolean;
  candSubmissionId?: string;
  candSubOnboardingTaskIds?: any;
  candidateId?: string;
  status?: string;
  statusIntId?: any;
  subStatusId?: any;
  candidateName?: string;
  showCandidateOwnershipModal?: boolean;
  showSubmitModal?: boolean;
  showSendCredentialsModal?: boolean;
  showSendBackModal?: boolean;
  showFullyCredentialModal?: boolean;
  showTemporaryCredentialModal?: boolean;
  hideBtn?: any;
  showRejectCandidateModal?: boolean;
  showWithdrawModal?: boolean;
  jobWfTypeId?: string;
  showUnsavedTasksModal?: boolean
  isVendorRole?: any;
  positionId?: string;
  locationId?: string;
  divisionId?: string;
  jobPositionId?: string;
  clientId?: string;
  isPilot?: boolean;
  isRateLockdown?: any;
  submittedVendorId?: string;
  reqCreatedDate?: any;
  targetStartDate?: any;
  targetEndDate?: any;
  projectedStartDate?: any;
  projectedEndDate?: any;
  hours?: any;
  isDirty?: boolean;
  maxForecastingHours?: any;
  showAssignmentProjectionModal?: boolean;
  isAssignmentProjections?: boolean;
  serviceType?: any;
  reqEndDate?: any;
  reqStartDate?: any;
  openAlert?: boolean;
  isForecastEnableInWf?: boolean;
  isDocExecuted: boolean;
}

class ViewOnboarding extends React.Component<
  ViewOnboardingProps,
  ViewOnboardingState
> {
  childRef: React.RefObject<TasksComponent> = React.createRef();
  action: string;
  actionId: string;
  statusId: string;
  eventName: string;
  hasUnsavedData: [];
  alertMessage: any;
  public forecast: any;
  constructor(props: ViewOnboardingProps) {
    super(props);
    this.state = {
      reqId: "",
      reqNo: "",
      location: "",
      clientId: auth.getClient(),
      candSubDetails: {},
      candSubOnboardingTaskIds: [],
      hideBtn: [],
      isVendorRole: isRoleType(AuthRoleType.Vendor),
      targetStartDate: null,
      targetEndDate: null,
      projectedStartDate: null,
      projectedEndDate: null,
      hours: null,
      isDocExecuted: false
    };
  }

  componentDidMount() {
    const { subId } = this.props.match.params;
    this.setState({ candSubmissionId: subId });
    this.getCandidateSubmissionDetails(subId);
    this.getClientSettings(this.state.clientId);
  }

  async getCandidateSubmissionDetails(candSubmissionId) {
    this.setState({ showLoader: true, status: "" });
    await axios
      .get(`api/candidates/workflow/${candSubmissionId}`)
      .then((res:any) => {
        this.setState({
          reqNo: res.data.reqNumber,
          reqId: res.data.reqId,
          candSubDetails: res.data,
          candidateId: res.data.candidateId,
          location: res.data.location,
          position: res.data.position,
          status: res.data.status,
          statusIntId: res.data.statusIntId,
          subStatusId: res.data.subStatusId,
          showLoader: false,
          jobWfTypeId: res.data.jobWfTypeId,
          locationId: res.data.locationId,
          divisionId: res.data.divisionId,
          positionId: res.data.positionId,
          jobPositionId: res.data.jobPositionId,
          isPilot: res.data.isPilot,
          submittedVendorId: res.data.submittedVendorId,
          reqCreatedDate: res.data.reqCreatedDate,
          targetStartDate: res.data.targetStartDate,
          targetEndDate: res.data.targetEndDate,
          projectedStartDate: res.data.targetStartDate,
          projectedEndDate: res.data.targetEndDate,
          reqStartDate: localDateTime(res.data.reqStartDate),
          reqEndDate: localDateTime(res.data.reqEndDate),
        }, () => {
          this.getForecastStatusInWf(); 
          this.getDocPortfolio(candSubmissionId);
        });
      });
  }

  getForecastStatusInWf = () => {
    const {jobWfTypeId} = this.state;
    if (jobWfTypeId != undefined){
      CommonDataService.getLetterOrForecastStatusInWf(jobWfTypeId)
      .then((data:any) => this.setState({isForecastEnableInWf: data.isForecast}));
    }
  }

  getDocPortfolio = (candSubmissionId) => {
    var submission = candSubmissionId;
    var queryParams = '';
    if (submission != "" && submission != null && submission != undefined) {
        queryParams = "?candSubmissionId=" + candSubmissionId + "&$filter=docType eq 'Confirmation Letter' and (status eq 'Executed' or status eq 'Client Signed')"
    }
    axios.get(`/api/candidates/${this.state.candidateId}/documents` + queryParams).then((res: any) => {
        if (res) {
          let docExecuted = res.data?.filter(x => (x.status === DocStatus.EXECUTED || x.status === DocStatus.CLIENTSIGNED) && x.candidateId == this.state.candSubmissionId && x.docType == DocType.CONFIRMATIONLETTER);
          this.setState({ isDocExecuted:  docExecuted && docExecuted.length ? true : false })
        }
    });
  }

  candInfoCallback = (candidateInfo) => {
    this.setState({
      candidateEmail: candidateInfo.email,
      candidateName: candidateInfo.name,
      candidatePhoneNumber: candidateInfo.phoneNumber,
      candidateMobileNumber: candidateInfo.mobileNumber,
    });
  };

  getAllTaskData = (data) => {
    this.checkTemporaryAndApproved(data);
  };

  checkTemporaryAndApproved = (data) => {
    let mandatoryTasks = data.filter(i => i.isMandatory == true)
    let pendingTask = mandatoryTasks.filter((i) => i.statusIntId == CandSubOnBoardTaskStatusIds.PENDINGSUBMISSION || i.statusIntId == CandSubOnBoardTaskStatusIds.SENTBACK);
    let totalPendingTask = data.filter((i) => i.statusIntId == CandSubOnBoardTaskStatusIds.PENDINGSUBMISSION || i.statusIntId == CandSubOnBoardTaskStatusIds.SENTBACK);
    let underReviewAndApprovedTask = mandatoryTasks.filter(
      (i) =>
        i.statusIntId !== CandSubOnBoardTaskStatusIds.UNDERREVIEW &&
        i.statusIntId !== CandSubOnBoardTaskStatusIds.APPROVED
    );
    let underReviewTasks = mandatoryTasks.filter(
      (i) => i.statusIntId === CandSubOnBoardTaskStatusIds.UNDERREVIEW
    );
    if (totalPendingTask.length != 0) {
      if (pendingTask.length == 0) {
        if (underReviewAndApprovedTask.length > 0) {
          this.setState({ hideBtn: ["TemporaryCredential", "FullyCredential", CandidateWorkflowActionBtns.ASSIGN] });
        } else {
          if (underReviewTasks.length > 0) {
            this.setState({ hideBtn: ["FullyCredential", CandidateWorkflowActionBtns.ASSIGN] });
          }
          else {
            this.setState({ hideBtn: ["TemporaryCredential", CandidateWorkflowActionBtns.ASSIGN] });
          }
        }
      }
      else {
        this.setState({ hideBtn: ["TemporaryCredential", "FullyCredential", CandidateWorkflowActionBtns.ASSIGN] });
      }
    } else {
      if (underReviewAndApprovedTask.length > 0) {
        this.setState({ hideBtn: ["TemporaryCredential", "FullyCredential", "Submit", CandidateWorkflowActionBtns.ASSIGN] });
      } else {
        if (underReviewTasks.length > 0) {
          this.setState({ hideBtn: ["FullyCredential", "Submit", CandidateWorkflowActionBtns.ASSIGN] });
        }
        else {
          this.setState({ hideBtn: ["TemporaryCredential, Submit", CandidateWorkflowActionBtns.ASSIGN] });
        }
      }
    }
  }

  handleActionClick = (action, nextStateId?, eventName?, actionId?) => {
    let change = {};
    let property = `show${action.replace(/ +/g, "")}Modal`;
    let selectedDataFromGrid = this.childRef.current.getSelectedItems(true);
    const { selectedIds, selectedItems, shouldOpen } = selectedDataFromGrid;
    if (action === "Submit") {
      if (this.childRef.current.OnFormaDataSubmit() == true) {
        this.setState({ showSubmitModal: true })
      }
    } else if (action === "Send Credentials") {
      if (shouldOpen && selectedItems.length > 0) {
        this.setState({
          candSubOnboardingTaskIds: selectedDataFromGrid.selectedIds,
        });
        change[property] = true;
      }
      else if (shouldOpen && selectedItems.length == 0) {
        errorToastr(NO_DOC_FOR_CREDENTIALING);
      } else {
        selectedItems.length > 0
          ? errorToastr(SELECT_ONLY_SUBMITTED_TASK)
          : errorToastr(SELECT_ATLEAST_ONE_SUBMITTED);
      }
    } else if (action === "Send Back") {
      if (selectedIds.length > 0 && shouldOpen) {
        this.setState({
          candSubOnboardingTaskIds: selectedDataFromGrid.selectedIds,
        });
        change[property] = true;
      } else {
        selectedDataFromGrid.selectedIds.length > 0
          ? errorToastr(SELECT_SUBMITTED_TASK)
          : errorToastr(SELECT_ATLEAST_ONE_TASK);
      }
    } else {
      change[property] = true;
    }
    this.setState(change);
    this.statusId = nextStateId;
    this.eventName = eventName;
    this.actionId = actionId;
    this.action = action;
  };

  candidateStatusUpdate = (successMsg, modal, props?) => {
    this.setState({ showLoader: true });
    const data = {
      candSubmissionId: this.state.candSubmissionId,
      statusId: this.statusId,
      eventName: this.eventName,
      actionId: this.actionId,
      ...props,
    };
    axios
      .put("api/candidates/workflow/status", JSON.stringify(data))
      .then((res) => {
        successToastr(successMsg);
        this.setState({ showLoader: false });
        history.goBack()
        // history.push("/candidates/submitted/" + this.state.reqId);
      });
    // close the modal
    let change = {};
    change[modal] = false;
    this.setState(change);
  };

  handleDisable = () => {
      var ele = document.getElementById("SubmitToHiringManager");
      if (ele) {
          ele.setAttribute("disabled", "true");
      }
  };

  handleEnable = () => {
      var ele = document.getElementById("SubmitToHiringManager");
      if (ele) {
          ele.removeAttribute("disabled");
      }
  };

  candidateTaskUpdate = (successMsg, modal, props?, statusIntId?) => {
    this.setState({ showLoader: true });
    const data = {
      candSubmissionId: this.state.candSubmissionId,
      candSubOnboardingTaskIds: this.state.candSubOnboardingTaskIds,
      statusIntId: statusIntId,
      statusId: this.statusId,
      eventName: this.eventName,
      actionId: this.actionId,
      actionName: this.action,
      ...props,
    };
    axios
      .put("api/candidates/candsubonboardingtask/status", JSON.stringify(data))
      .then((res) => {
        successToastr(successMsg);
        this.setState({ showLoader: false });
        // history.push("/candidate/manage/" + this.state.reqId);
        // history.push("/candidates/submitted/" + this.state.reqId);
        history.goBack()
      }, () => { this.setState({ showLoader: false }); });
    // close the modal
    let change = {};
    change[modal] = false;
    this.setState(change);
  };

    getClientSettings = (clientId) => {
        getClientSettingsData(clientId).then((res) => {
            applySettingFilters(res, SettingCategory.CANDIDATE, SETTINGS.RATE_LOCKDOWN, (response) => {
                this.setState({ isRateLockdown: response });
            });

            applySettingFilters(res, SettingCategory.REPORT, SETTINGS.ASSIGNMENT_PROJECTION, (response) => {
                this.setState({ isAssignmentProjections: response });
            });

            applySettingFilters(res, SettingCategory.CANDIDATE, SETTINGS.MAX_FORECASTING_HOURS, (response) => {
                this.setState({ maxForecastingHours: response });
            });
        });
  };

  handleChange = (e) => {
    let change = { isDirty: true };
    change[e.target.name] = e.target.value;
    this.setState(change);
    if(e.target.name == "targetStartDate"){
      this.setState({ projectedStartDate: e.target.value });
    }else if(e.target.name == "targetEndDate"){
      this.setState({ projectedEndDate: e.target.value });
    }
  };

  generateProjections = (isOverrideProjection = false) => {
    const { isForecastEnableInWf, isAssignmentProjections } = this.state;
      if (isAssignmentProjections == true && isForecastEnableInWf && this.state.maxForecastingHours != null && this.state.maxForecastingHours != "" && this.state.maxForecastingHours >= 0 && this.state.hours > this.state.maxForecastingHours){
        this.alertMessage = MAX_FORECASTING_HOURS_MSG(this.state.maxForecastingHours);
        this.setState({ openAlert: true });
        return false;
    }
    
    this.setState({ showLoader: true });
    const data = {
      candSubmissionId: this.state.candSubmissionId,
      targetStartDate: localDateTime(this.state.targetStartDate),
      targetEndDate: localDateTime(this.state.targetEndDate),
      projectedStartDate: localDateTime(this.state.projectedStartDate),
      projectedEndDate: localDateTime(this.state.projectedEndDate),
      hours: this.state.hours,
      isOverrideProjection: isOverrideProjection,
      isGenerateGlobalProjection: true,
      statusId: this.state.candSubDetails.statusIntId
    };
    axios.post("api/candidates/generateprojections", JSON.stringify(data)).then((res:any) => {
      if (res.data && !res.data.isSuccess) {
        errorToastr(res.data.statusMessage);
        this.setState({
          showLoader: false,
          serviceType: res.data.responseCode,
          showAssignmentProjectionModal: true
        });
      } else {
        successToastr(GENERATE_PROJECTION_SUCCESS_MSG);
        this.setState({ showLoader: false, hours: null, projectedStartDate: this.state.targetStartDate, projectedEndDate: this.state.targetEndDate });
      }
    }).catch(error => {
      this.setState({
        showLoader: false
      });
    });
  };

  render() {
    const { 
      candSubmissionId,
      reqId,
      status, 
      candSubDetails, 
      showLoader,
      targetStartDate,
      targetEndDate,
      projectedStartDate,
      projectedEndDate,
      hours,
      isAssignmentProjections,
      isForecastEnableInWf
    } = this.state;

    console.log(isForecastEnableInWf);
    const projectionInfo = {
      targetStartDate,
      targetEndDate,
      projectedStartDate,
      projectedEndDate,
      candSubDetails,
      hours
    };
    return (
      <React.Fragment>
        <div className="col-11 mx-auto pl-0 pr-0 mt-3">
          <div className="col-12 p-0 shadow pt-1 pb-1">
            <PageTitle
              title="Candidate Onboarding"
              reqNumber={this.state.reqNo}
              candSubmissionId={this.state.candSubmissionId}
              pageUrl={`/requisitions/view/${this.state.reqId}`}
            />
            <div className="col-12">
              <Collapsible
                trigger={candTriggerName(
                  "Candidate Information",
                  this.state.status,
                  "",
                  this.state.subStatusId
                )}
                open={true}
              >
                {this.state.showLoader && <SkeletonWidget />}
                {!this.state.showLoader &&
                  this.state.candSubDetails &&
                  this.state.candidateId && (
                    <CandidateInformation
                      callbackFromParent={this.candInfoCallback}
                      candidateId={this.state.candidateId}
                      location={this.state.location}
                      submissionData={this.state.candSubDetails}
                    />
                  )}

                <div className="col-12 col-sm-4 col-lg-4 mt-1 mt-sm-0">
                  <label className="mb-0 font-weight-bold">Comments</label>
                  <span
                    onClick={() => this.setState({ openCommentBox: true })}
                    className="text-underline cursorElement align-middle"
                  >
                    <FontAwesomeIcon
                      icon={faClock}
                      className="ml-1 active-icon-blue ClockFontSize"
                    />
                  </span>
                </div>
              </Collapsible>
              <Collapsible trigger={candTriggerName("Bill Rates and Expenses")} open={true}>
                  {this.state.candSubmissionId && this.state.candidateName && this.state.locationId && this.state.jobPositionId && (
                      <BillRateAndExpenses
                          candSubmissionId={this.state.candSubmissionId}
                          candidateName={this.state.candidateName}
                          locationId={this.state.locationId}
                          positionId={this.state.jobPositionId}
                          candidateSubStatusIntId={this.state.statusIntId}
                          divisionId={this.state.divisionId}
                          candidateSubStatus={this.state.status}
                          handleDisable={() => this.handleDisable()}
                          handleEnable={() => this.handleEnable()}
                          isRateLockdown={this.state.isRateLockdown}
                          isPilot={this.state.isPilot}
                          location={this.state.location}
                          position={this.state.position}
                          vendorId={this.state.submittedVendorId}
                          reqCreatedDate={this.state.reqCreatedDate}
                          isDocExecuted={this.state.isDocExecuted}
                      ></BillRateAndExpenses>
                  )}
              </Collapsible>
              <Collapsible trigger={candTriggerName("Presentation Information")} open={true}>
                  {this.state.candSubmissionId &&
                      this.state.candidateName &&
                      (
                          <CandSubPresentationInfo
                              candidatePhoneNumber={this.state.candidateMobileNumber ? this.state.candidateMobileNumber : this.state.candidatePhoneNumber}
                              candidateEmail={this.state.candidateEmail}
                              candSubmissionId={this.state.candSubmissionId}
                              isEnable={false} />
                      )}
              </Collapsible>
              <Collapsible trigger={candTriggerName("Onboarding")} open={true}>
                {!this.state.showLoader &&
                  this.state.candSubDetails &&
                  this.state.candidateId &&
                  this.state.reqId && (
                    <TasksComponent
                      clientId={localStorage.getItem("UserClientId")}
                      ref={this.childRef}
                      reqId={this.state.reqId}
                      candidateId={this.state.candidateId}
                      candSubmissionId={candSubmissionId}
                      status={this.state.status}
                      statusIntId={this.state.statusIntId}
                      statusId={this.statusId}
                      eventName={this.eventName}
                      getAllTaskData={this.getAllTaskData}
                      candidateTaskUpdate={this.candidateTaskUpdate}
                      getCandidateSubmissionDetails={() => this.getCandidateSubmissionDetails(this.state.candSubmissionId)}
                    />
                  )}
                {(this.state.candSubOnboardingTaskIds.length == 0 &&
                  this.state.showSendCredentialsModal) ? (
                  <ErrorComponent message={SELECT_ONE_TASK_TO_SEND} />
                ) : null}
              </Collapsible>

              {auth.hasPermissionV2(AppPermissions.FORECASTING_VIEW) && candSubDetails && (candSubDetails.statusIntId == CandSubStatusIds.PENDINGONBOARDING || candSubDetails.statusIntId == CandSubStatusIds.PENDINGCREDENTIALING) && isAssignmentProjections == true && isForecastEnableInWf && (
              <Collapsible
                trigger={candTriggerName("Assignment Target Dates")}
                open={true}
              >
                {!showLoader && auth.hasPermissionV2(AppPermissions.FORECASTING_VIEW) && candSubDetails &&
                  candSubmissionId && (candSubDetails.statusIntId == CandSubStatusIds.PENDINGONBOARDING || candSubDetails.statusIntId == CandSubStatusIds.PENDINGCREDENTIALING) && isAssignmentProjections == true && isForecastEnableInWf && (
                    <ProjectionTargetDates
                      data={projectionInfo}
                      handleChange={this.handleChange}
                      showLoader={showLoader}
                      generateProjection={true}
                      handleGenerateProjections={this.generateProjections}
                      reqDates={{reqStartDate:this.state.reqStartDate, reqEndDate:this.state.reqEndDate}}
                    />
                  )}
              </Collapsible>
              )}
              {auth.hasPermissionV2(AppPermissions.FORECASTING_VIEW) && candSubDetails && (candSubDetails.statusIntId == CandSubStatusIds.PENDINGONBOARDING || candSubDetails.statusIntId == CandSubStatusIds.PENDINGCREDENTIALING) && isAssignmentProjections == true && isForecastEnableInWf && (
              <Collapsible
                trigger={candTriggerName("Assignment Forecast")}
                open={true}
              >
                {!showLoader && auth.hasPermissionV2(AppPermissions.FORECASTING_VIEW) && candSubDetails &&
                  candSubmissionId && (candSubDetails.statusIntId == CandSubStatusIds.PENDINGONBOARDING || candSubDetails.statusIntId == CandSubStatusIds.PENDINGCREDENTIALING) && isAssignmentProjections == true && isForecastEnableInWf && (
                    <AssignmentProjections
                      ref={(instance) => {
                        this.forecast = instance;
                      }}
                      candSubmissionId={candSubmissionId}
                      targetStartDate={this.state.targetStartDate}
                      targetEndDate={this.state.targetEndDate}
                    />
                  )}
              </Collapsible>
              )}

              <div className="col-12 col-sm-4 col-lg-4 mt-1 mb-2 mt-sm-0 px-0">
                <label className="mb-0 font-weight-bold">Comments</label>
                <span
                  onClick={() => this.setState({ openCommentBox: true })}
                  className="text-underline cursorElement align-middle"
                >
                  <FontAwesomeIcon
                    icon={faClock}
                    className="ml-1 active-icon-blue ClockFontSize"
                  />
                </span>
                <Comment
                  entityType={EntityType.CANDSUBMISSION}
                  entityId={candSubmissionId}
                />
              </div>
              {this.state.openCommentBox && (<CommentHistoryBox
                entityType={EntityType.CANDSUBMISSION}
                entityId={candSubmissionId}
                showDialog={this.state.openCommentBox}
                handleNo={() => {
                  this.setState({ openCommentBox: false });
                  document.body.style.position = "";
                }}
              />)}
            </div>
          </div>
        </div>
        {status && (this.state.subStatusId !== CandSubmissionSubStatusIds.Temporary && this.state.subStatusId !== undefined) &&
          (this.state.statusIntId !== CandSubStatusIds.READYTOWORK && this.state.statusIntId !== undefined) ? (
          <FormActions
            wfCode={CandidateWorkflow.CANDIDATE}
            jobWfTypeId={this.state.jobWfTypeId}
            entityId={this.state.candSubmissionId}
            currentState={status}
            handleClick={this.handleActionClick}
            // cancelUrl={`${CAND_SUB_MANAGE_URL}${reqId}`}
            handleClose={() => history.goBack()}
            disabBtn={this.state.hideBtn}
          />
        ) : (
          <CloseLink
            title={"Close"}
            pageUrl={`${CAND_SUB_MANAGE_URL}${reqId}`}
          />
        )}
        <ConfirmationModal
          message={SUBMIT_ONBOARD_MSG}
          showModal={this.state.showSubmitModal}
          handleYes={(e) =>
            this.candidateTaskUpdate(
              SUBMIT_ONBOARD_SUCCESS_MSG,
              "showSubmitModal",
              null,
              CandSubOnBoardTaskStatusIds.SUBMITTED
            )
          }
          handleNo={() => {
            this.setState({ showSubmitModal: false });
          }}
        />

        {this.state.showTemporaryCredentialModal && this.actionId && (
          <TemporaryModal
            action={this.action}
            actionId={this.actionId}
            message={TEMP_CRED_MSG(this.state.candidateName)}
            showModal={this.state.showTemporaryCredentialModal}
            handleYes={(data) =>
              this.candidateStatusUpdate(
                TEMP_CRED_ONBOARD_SUCCESS_MSG,
                "showTemporaryCredentialModal",
                data
              )
            }
            handleNo={() => {
              this.setState({ showTemporaryCredentialModal: false });
            }}
          />
        )}
        <ConfirmationModal
          message={FULLY_CREDENTIALS_ONBOARD_MSG(this.state.candidateName)}
          showModal={this.state.showFullyCredentialModal}
          handleYes={(e) =>
            this.candidateStatusUpdate(
              FULLY_CRED_ONBOARD_SUCCESS_MSG,
              "showFullyCredentialModal"
            )
          }
          handleNo={() => {
            this.setState({ showFullyCredentialModal: false });
          }}
        />
        <div id="advancesearchCompoent-popup">
          {this.state.showSendCredentialsModal && (
            <div className="col-12">
              <Dialog className="For-all-responsive-height">
                <SendCredentials
                  filesData={
                    this.childRef.current.getSelectedItems(true).selectedItems
                  }
                  candSubmissionId={this.state.candSubmissionId}
                  candSubOnboardingTaskIds={this.state.candSubOnboardingTaskIds}
                  notificationTypeId={NotificationTypeIds.SENDCREDENTIAL}
                  candidateName={this.state.candidateName}
                  statusId={this.statusId}
                  eventName={this.eventName}
                  handleClose={() => {
                    this.setState({ showSendCredentialsModal: false });
                  }}
                  handleYes={() => {
                    this.setState({ showSendCredentialsModal: false });
                    this.childRef.current.getAllTasks();
                    this.getCandidateSubmissionDetails(this.state.candSubmissionId);
                  }}
                ></SendCredentials>
              </Dialog>
            </div>
          )}
        </div>
        {this.state.showSendBackModal && this.actionId && (
          <RejectModal
            action={this.action}
            actionId={this.actionId}
            message={SEND_BACK_MSG}
            showModal={this.state.showSendBackModal}
            handleYes={(data) =>
              this.candidateTaskUpdate(
                SEND_BACK_SUCCESS_MSG,
                "showSendBackModal",
                data,
                CandSubOnBoardTaskStatusIds.SENTBACK
              )
            }
            handleNo={() => {
              this.setState({ showSendBackModal: false });
            }}
          />
        )}
        {this.state.showRejectCandidateModal && this.actionId && (
          <RejectModal
            action={this.action}
            actionId={this.actionId}
            message={REJECT_CANDIDATE(null)}
            showModal={this.state.showRejectCandidateModal}
            handleYes={(data) => this.candidateStatusUpdate(REJECT_CANDIDATE_SUCCESS_MSG, "showRejectCandidateModal", data)}
            handleNo={() => { this.setState({ showRejectCandidateModal: false }); }}
          />
        )}
        {this.state.showWithdrawModal && this.actionId &&
          <RejectModal
            action={this.action}
            actionId={this.actionId}
            message={WITHDRAW_CANDIDATE(null)}
            showModal={this.state.showWithdrawModal}
            handleYes={(data) => this.candidateStatusUpdate(WITHDRAW_CANDIDATE_SUCCESS_MSG, "showWithdrawModal", data)}
            handleNo={() => {
              this.setState({ showWithdrawModal: false });
            }}
          />
        }
        {this.state.openAlert && (
          <AlertBox
            handleNo={() => {
              this.setState({ openAlert: false });
            }}
            message={this.alertMessage}
            showModal={this.state.openAlert}
          ></AlertBox>
        )}
        {/* <ConfirmationModal
          message={SAVE_UNSAVED_INTERVIEW_RESULT}
          showModal={this.state.showUnsavedTasksModal}
          handleYes={async (e) => {
            this.SaveTasks()
          }}
          handleNo={() => {
            this.setState({ showUnsavedTasksModal: false });
          }}
        /> */}
        <ConfirmationModal
          message={OVERRIDE_EXISTING_PROJECTION_GENERATE_CONFIRMATION_MSG(this.state.serviceType)}
          showModal={this.state.showAssignmentProjectionModal}
          handleYes={() => {
            this.setState({ showAssignmentProjectionModal: false });
            this.generateProjections(true)
          }}
          handleNo={() => {
            this.setState({ showAssignmentProjectionModal: false });
          }}
        />
      </React.Fragment>
    );
  }
}

export default ViewOnboarding;